export default "__VITE_ASSET__Cl_XnsBy__"